<script setup>
import { RIHLogo, useAuthStore } from "@/entities";
import {
    BaseHeaderTemplate,
    BaseButton,
    IconBars,
    IconArrowRightFromBracket,
    buildAppUrl,
    vTooltip,
} from "@/shared";

defineProps({
    isSidebarCollapsed: {
        type: Boolean,
        default: false,
    },
});
defineEmits(["changeSidebarMode"]);

const authStore = useAuthStore();

const handleExit = async function () {
    await authStore.logout();

    location.replace(buildAppUrl(import.meta.env.VITE_APP_LK));
};
</script>

<template>
    <BaseHeaderTemplate
        class="the-header"
        :is-sidebar-collapsed="isSidebarCollapsed"
    >
        <template #logo>
            <RIHLogo :is-collapsed="isSidebarCollapsed" />
        </template>
        <template #content>
            <BaseButton
                class="the-header__collapse-btn the-header__btn"
                variant="white"
                type="square"
                @click="$emit('changeSidebarMode')"
            >
                <IconBars />
            </BaseButton>
            <BaseButton
                class="the-header__btn the-header__btn--ghost"
                variant="invisible"
                type="circle"
                v-tooltip.bottom="'Выход'"
                @click="handleExit"
            >
                <IconArrowRightFromBracket class="the-header__icon" />
            </BaseButton>
        </template>
    </BaseHeaderTemplate>
</template>

<style lang="scss" scoped>
.the-header {
    &__collapse-btn {
        // Бургер: белый фон + тёмные чёрточки. Без видимой рамки (border того же цвета что фон)
        --button-border-color: var(--button-color);
        --button-border-color-hover: var(--button-color);
        --button-width: var(--header-height);
        --button-height: var(--header-height);
        --button-border-radius: 0;

        flex-shrink: 0;

        margin-right: auto;

        ::v-deep(svg) {
            color: var(--c-neutral-70);
        }
    }

    &__fast-create-btn {
        margin-right: 10px;
        margin-left: 10px;
    }

    &__icon {
        pointer-events: none;

        &--lifebuoy {
            width: 20px !important;
            height: auto;
        }
    }

    &__btn {
        flex-shrink: 0;

        &:active {
            svg {
                color: var(--c-green-10) !important;
            }
        }
    }

    // Ghost-кнопки (Выход) — без teal фона, тёмная иконка
    &__btn--ghost {
        --button-color: transparent;
        --button-color-hover: rgba(15 22 36 / 6%);
        --button-color-active: rgba(15 22 36 / 10%);
        --button-border-color: transparent;
        --button-border-color-hover: transparent;
        --button-border-color-active: transparent;

        ::v-deep(svg) {
            color: var(--c-neutral-70);
        }

        &:hover ::v-deep(svg) {
            color: var(--c-text);
        }
    }
}
</style>
